import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/global.scss';

/**
 * Le point d'entree.
 *
 * Pas de `StrictMode`, et c'est delibere : en developpement il monte chaque
 * composant deux fois, ce qui ouvre DEUX WebSockets et fait donc rejoindre le
 * salon deux fois. On perdrait plus de temps a contourner ce double montage
 * qu'on n'en gagnerait a detecter des effets impurs.
 */
const host = document.getElementById('root');
if (!host) throw new Error('element #root introuvable');

createRoot(host).render(<App />);
